<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="wrapper-title">
        <p class="title">Información del usuario</p>
        <CloseButton @click="closeModal" />
      </div>

      <div class="wrapper-form">
        <GeneralInput
          v-model:text="name.val"
          :value="name.val"
          :label="'Nombre'"
          :has-error="name.enabled"
          :error="name.errors.length === 0 ? '' : name.errors[0]"
          class="input-full"
        />

        <GeneralInput
          v-model:text="userName.val"
          :value="userName.val"
          :label="'Nombre de usuario'"
          :has-error="userName.enabled"
          :error="userName.errors.length === 0 ? '' : userName.errors[0]"
          :is-disabled="isEdit"
        />

        <GeneralSelect
          v-model:text="role.val"
          :options="roles"
          :value="role.val"
          :label="'Rol'"
          :has-error="role.enabled"
          :error="role.errors.length === 0 ? '' : role.errors[0]"
        />

        <GeneralInput
          v-model:text="code.val"
          :value="code.val"
          :label="'Código empleado'"
          :has-error="code.enabled"
          :error="code.errors.length === 0 ? '' : code.errors[0]"
        />

        <GeneralInput
          v-model:text="price.val"
          :value="price.val"
          :label="'Precio base'"
          :has-error="price.enabled"
          :error="price.errors.length === 0 ? '' : price.errors[0]"
        />

        <GeneralInput
          v-model:text="password.val"
          :value="password.val"
          :label="'Contraseña'"
          :has-error="password.enabled && !isEdit"
          :error="password.errors.length === 0 ? '' : password.errors[0]"
        />

        <GeneralInput
          v-model:text="email.val"
          :value="email.val"
          :label="'Correo'"
          :has-error="email.enabled"
          :error="email.errors.length === 0 ? '' : email.errors[0]"
        />
      </div>
      <StandardButton
        :buttonLabel="'Guardar'"
        class="margin-button"
        :is-disabled="disabledForm"
        @click="createEditUser"
      />
    </div>
  </div>
</template>

<script lang="ts">
import GeneralInput from "@/components/commons/controls/GeneralInput.vue";
import GeneralSelect from "@/components/commons/controls/GeneralSelect.vue";
import { createEditUserValidator } from "@/ux/users/validators/createEditUserValidator";
import CloseButton from "@/components/commons/controls/CloseButton.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { watch, ref, Ref, defineComponent, computed } from "vue";
import { User } from "@/business/users/domain/user";
import { SelectOption } from "@/business/shared/commons/selectOption";

export default defineComponent({
  name: "ModalCreateEditUser",
  props: {
    user: {
      type: Object as () => User | null,
      required: false,
    },
    roles: {
      type: Array as () => SelectOption[],
      required: true,
    },
  },
  components: {
    GeneralInput,
    GeneralSelect,
    CloseButton,
    StandardButton,
  },

  setup(props, context) {
    const {
      name,
      userName,
      role,
      code,
      price,
      password,
      email,
      successForm,
      successFormEdit,
      reset,
    } = createEditUserValidator();

    const isEdit: Ref<boolean> = ref(false);

    function closeModal() {
      context.emit("close");
      reset();
    }

    watch(
      () => props.user,
      () => {
        reset();
        if (props.user != null) {
          name.value.val = props.user.name;
          userName.value.val = props.user.username;
          role.value.val = props.user.rol.idRole;
          code.value.val = props.user.emplid;
          price.value.val = props.user.base_price;
          email.value.val = props.user.email;
          isEdit.value = true;
        } else {
          isEdit.value = false;
        }
      }
    );

    function createUser() {
      const newUserForm = {
        name: name.value.val,
        userName: userName.value.val,
        role: role.value.val,
        code: code.value.val,
        price: price.value.val,
        password: password.value.val,
        email: email.value.val,
      };

      context.emit("create", newUserForm);
    }

    function editUser() {
      const editUserForm = {
        name: name.value.val,
        userName: userName.value.val,
        role: role.value.val,
        code: code.value.val,
        price: price.value.val,
        password: password.value.val,
        email: email.value.val,
      };

      context.emit("edit", editUserForm);
    }

    function createEditUser() {
      if (!isEdit.value) {
        createUser();
      } else {
        editUser();
      }
    }

    const disabledForm = computed(() => {
      return isEdit.value ? successFormEdit.value : successForm.value;
    });

    return {
      closeModal,
      name,
      userName,
      role,
      code,
      price,
      password,
      email,
      disabledForm,
      reset,
      createEditUser,
      isEdit,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/users/styles/modalCreateEditUserStyle";
</style>
